interface Details { title: string, description: string, others?: string, imagePath?: string }
const htbSteps: { label?: string; imagePath: string; description: string, details?: Details }[] = [
  {
    label: 'Step 1',
    description: 'CHOOSE YOUR FRAME & LENSES',
    imagePath: '/images/how-to-buy/how-to-buy-step1.jpg',
    details: {
      title: "VisionHub, <br/> it's 240 models",
      description: 'With a catalog of frames gathering many different brands and fashion, combining SV and PAL lenses also as sunglasses, readers and lots of different visual corrections, VisionHub is proud to say that :',
      others: 'You will find what you need !',
      imagePath: '/images/about/about-glass-step1.jpg'
    }
  },
  {
    label: 'Step 2',
    description: 'TYPE IN YOUR PRESCRIPTION',
    imagePath: '/images/how-to-buy/how-to-buy-step2.jpg',
    details: {
      title: "The prescription’s role",
      description: 'An optical advice is the prescription written by a professional such as an ophthalmologist (in France) or an optometrist (in Anglo-Saxon countries), which indicates the value of all the parameters necessary to create your equipement of corrective lenses.',
      others: 'It allows us to make your glasses the closest to your visual needs.',
      imagePath: '/images/about/about-prescription-role-step2.png'
    }
  },
  {
    label: 'Step 3',
    description: 'GO TO A KIOSK TO SCAN YOUR FACE',
    imagePath: '/images/how-to-buy/how-to-buy-step3.jpg',
    details: {
      title: "Scan your face at a VisionHub Kiosk",
      description: 'Live Measurement Frame service allows you to take your measurements quickly with or without assistance, as easily as for an ID photo. This service is the most important step of your purchasing experience.',
      imagePath: '/images/about/about-scan-step3.png'
    }
  },
  {
    label: 'Step 4',
    description: 'GET YOUR GLASSES',
    imagePath: '/images/how-to-buy/how-to-buy-step4.jpg',
    details: {
      title: "VisionHub delivers you anytime, anywhere.",
      description: 'Our delivery times change from one country to another. Contact your favorite retailer to make sure you have the proper details.',
      imagePath: '/images/about/about-deliver-step4.png'
    }
  },
];

export default htbSteps;
  